module.exports = __webpack_public_path__ + "static/media/close-icon.d6633996.svg";